import React, { FunctionComponent } from 'react'
import { Link } from '@lightspeed/unified-components-helios-theme/react'
import { InputErrorMessage } from '../InputErrorMessage'
import {
  useLineItemQuantityErrorModel,
  LineItemQuantityErrorProps,
} from './useLineItemQuantityErrorModel'

export const LineItemQuantityError: FunctionComponent<LineItemQuantityErrorProps> = props => {
  const model = useLineItemQuantityErrorModel(props)

  if (!model.errorMessage) {
    return null
  }

  return (
    <InputErrorMessage
      errorElement={
        <>
          {model.errorMessage}
          {model.link && (
            <Link
              appearance="secondary"
              customClasses={{
                content: ['text-no-default', 'typography-body-xs'],
              }}
              onClick={model.link.onClick}
              customDataAttributes={{
                container: {
                  'data-cy': 'ignore-low-stock-warning',
                  'data-track': model.link.trackingLabel,
                },
              }}
            >
              {model.link.label}
            </Link>
          )}
        </>
      }
    />
  )
}
